import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FieldTree } from '@angular/forms/signals'

import { LaskunTyyppi } from '@lemon/core-firebase/model/lasku'
import { TuettuKieli, Valuutta } from '@lemon/core/model/common'
import { KonfiguraatioPalvelu } from '../../service/lasku/configuration.service'

import { LemonTranslationService } from 'app/_jaettu-angular/service/lemon-translation.service'
import { BehaviorSubject, Observable } from 'rxjs'
import { LaskuLomake } from '../../../laskut/lasku-rivit.component'

@Component({
  selector: 'app-lasku-ylaosan-dropparit',
  templateUrl: './lasku-ylaosan-dropparit.component.html',
  styleUrls: ['./lasku-ylaosan-dropparit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LaskuYlaosanDropparitComponent {
  @Input() parent: FieldTree<LaskuLomake>
  @Input() naytaLaskunTyyppiObservable: Observable<boolean>

  kielet: BehaviorSubject<TuettuKieli[]> = new BehaviorSubject(['fi', 'en'])
  onkoEnnakkoLasku: BehaviorSubject<boolean[]> = new BehaviorSubject([false, true])
  valuutatObservable: Observable<Valuutta[]>
  tyypitObservable: Observable<LaskunTyyppi[]>
  kieliObservable: Observable<TuettuKieli>

  constructor(
    private _konfiguraatioPalvelu: KonfiguraatioPalvelu,
    private _translationService: LemonTranslationService,
  ) {
    this.valuutatObservable = this._konfiguraatioPalvelu.valuutatObservable
    this.tyypitObservable = this._konfiguraatioPalvelu.tyypitObservable
    this.kieliObservable = this._translationService.currentLanguageObservable
  }

  vertaaTyyppia = (o1: LaskunTyyppi, o2: LaskunTyyppi): boolean => {
    if (o1 && o2) {
      // console.log(o1, o2)
      return o1.avain === o2.avain
    }
    return false
  }
}
